import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import MosaicGrid from '../components/MosaicGrid';

export default function Album() {
  const { slug } = useParams();
  const [album, setAlbum] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('albums').select('*').eq('slug', slug).single()
      .then(({ data }) => {
        setAlbum(data);
        if (data) {
          supabase
            .from('photos').select('*, photo_tags(tags(name))').eq('album_id', data.id).order('created_at', { ascending: true })
            .then(({ data: photos }) => { setPhotos(photos || []); setLoading(false); });
        } else {
          setLoading(false);
        }
      });
  }, [slug]);

  if (loading) return null;

  if (!album) {
    return (
      <main style={{ padding: '8rem 2.5rem' }}>
        <p style={{ fontSize: 'var(--t-body)', color: 'var(--ink-faint)' }}>Album not found.</p>
        <Link to="/photos" style={{ fontSize: 'var(--t-body)', color: 'var(--ink-mid)', marginTop: '1rem', display: 'inline-block' }}>← Back</Link>
      </main>
    );
  }

  return (
    <main style={{ paddingTop: '52px' }}>
      <div style={{ padding: '2.5rem 2.5rem 2rem', borderBottom: '1px solid var(--rule)', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div>
          <Link to="/photos" style={{ fontSize: 'var(--t-meta)', color: 'var(--ink-faint)', display: 'block', marginBottom: '0.75rem' }}>← Photos</Link>
          <h1 style={{ fontSize: 'var(--t-sub)', fontWeight: 500 }}>{album.name}</h1>
          {album.description && (
            <p style={{ marginTop: '0.4rem', fontSize: 'var(--t-body)', color: 'var(--ink-mid)', lineHeight: 'var(--body-height)' }}>{album.description}</p>
          )}
        </div>
        <span style={{ fontSize: 'var(--t-meta)', color: 'var(--ink-faint)' }}>
          {photos.length} {photos.length === 1 ? 'frame' : 'frames'}
        </span>
      </div>
      <div style={{ padding: '2px' }}>
        <style>{`:root { --mosaic-cols: 4; } @media (max-width: 1100px) { :root { --mosaic-cols: 3; } } @media (max-width: 700px) { :root { --mosaic-cols: 2; } }`}</style>
        <MosaicGrid photos={photos} gap={2} />
      </div>
    </main>
  );
}
